import { Outlet, createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { queries } from "@/lib/queries";

export const Route = createFileRoute("/app/$workspaceId")({
  loader: async ({ context, params }) => {
    const workspace = await context.queryClient.query({
      ...queries.workspace(params.workspaceId),
      staleTime: "static",
    });
    try {
      localStorage.setItem("iagenix-ads-workspace", workspace.id);
    } catch {
      /* sem localStorage */
    }
    return { workspace };
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
